import React from "react";
import { connect } from "react-redux";
import LimitLine from "../../GameHeader/Stats/LimitLine";
import { formatNumberForceSigned } from "../../../lib/commonFunctions";

const WeaponsBalance = ({ weaponsBalance }) => (
  <React.Fragment>
    <h3 className="title">Weapons balance</h3>
    Smiths: <span
    className={weaponsBalance.production.smiths > 0 ? "positive"
      : ""}>{formatNumberForceSigned(weaponsBalance.production.smiths)}</span><br/>
    {!!weaponsBalance.production.guilds && <>
      Guild: <span className={"positive"}>{formatNumberForceSigned(weaponsBalance.production.guilds)}</span><br />
    </>}
    <br />
    <LimitLine
      amount={weaponsBalance.limit.amount}
      limit={weaponsBalance.limit.limit}
      market={weaponsBalance.limit.market}
    />
  </React.Fragment>
);

const mapStateToProps = state => ({
  weaponsBalance: state.governorate.resourceBalances.weapons,
});

export default connect(mapStateToProps)(WeaponsBalance);
